import { useState, useMemo } from 'react'

import EditIcon from '@mui/icons-material/Edit'
import SearchIcon from '@mui/icons-material/Search'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import {
  GridColDef,
  GridValueGetterParams,
  GridRenderCellParams,
} from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import Table from 'components/Table'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

import Delete from './delete'

export default function Suppliers() {
  const navigate = useNavigate()

  const { data } = useQuery<SupplierApiResponse[]>(
    QUERY_KEYS.SUPPLIERS.LIST,
    () => ApiService.Suppliers.getAll(),
  )

  const [deleteConfirmation, setDeleteConfirmation] = useState<
    SupplierApiResponse | undefined
  >()

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'type',
        headerName: 'Tipo',
        flex: 1,
        valueGetter: (params) =>
          params.row?.type === 'pf' ? 'Pessoa física' : 'Pessoa jurídica',
      },
      { field: 'name', headerName: 'Nome', flex: 1 },
      { field: 'fantasy_name', headerName: 'Nome fantasia', flex: 1 },
      { field: 'contact_name', headerName: 'Nome de contato', flex: 1 },
      {
        field: 'city',
        headerName: 'Cidade',
        valueGetter: (params: GridValueGetterParams<SupplierApiRequest>) =>
          `${params.row.city || ''}/${params.row.uf || ''}`,
        flex: 1,
      },
      { field: 'cell_phone', headerName: 'Celular', flex: 1 },
      { field: 'phone', headerName: 'Telefone', flex: 1 },
      {
        field: 'actions',
        headerName: 'Ações',
        width: 80,
        sortable: false,
        renderCell: (params: GridRenderCellParams<SupplierApiResponse>) => {
          return (
            <>
              <SearchIcon
                onClick={() => {
                  navigate(ROUTES.SUPPLIERS.VIEW(params.row.id))
                }}
              />
              <EditIcon
                onClick={() => {
                  navigate(ROUTES.SUPPLIERS.EDIT(params.row.id))
                }}
              />
            </>
          )
        },
      },
    ],
    [navigate],
  )

  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth={false}>
          <Box>
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
              }}
            >
              <Typography sx={{ m: 1 }} variant="h4">
                Fornecedores
              </Typography>

              <Box sx={{ m: 1 }}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    navigate(ROUTES.SUPPLIERS.CREATE)
                  }}
                >
                  Adicionar
                </Button>
              </Box>
            </Box>
          </Box>

          <Card sx={{ mt: 3 }}>
            <CardContent>
              <Table rows={data} columns={columns} />
            </CardContent>
          </Card>
        </Container>
      </Box>

      <Delete
        opened={!!deleteConfirmation}
        closeModal={() => setDeleteConfirmation(undefined)}
        supplier={deleteConfirmation as SupplierApiResponse}
      />
    </>
  )
}
